export default __webpack_public_path__ + "static/media/house.ca1d196c.svg";